export const referral = {
  name: 'referral',
  title: 'referral.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-referral.vue'),
  route: { name: 'referral.index' },
  children: [
    {
      title: 'referral.breadcrumb.user.index',
      route: { name: 'referral.user.index' }
    },
    {
      title: 'referral.breadcrumb.profit.index',
      route: { name: 'referral.profit.index' }
    },
    {
      title: 'referral.breadcrumb.request.index',
      route: { name: 'referral.request.index' }
    }
  ]
};
